// extracted by mini-css-extract-plugin
module.exports = {"lbqgwex":"lbqgwex"};